import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import i18n from '@/plugins/i18n';
import Tawk from 'vue-tawk';

Vue.config.productionTip = false

Vue.use(Tawk, {
  tawkSrc: 'https://embed.tawk.to/6028348d918aa261273ea149/1euegqi89'
})

/*
new Vue({
   vuetify,
  render: h => h(App),
}).$mount('#app')
*/

const vm = new Vue({
  i18n,
  vuetify,
  render: h => h(App),
});


window.onload = function() {
  vm.$mount('#app');
}
